import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TokenDataService } from "./token-data.service";
import * as loadsh from 'lodash';

import { Router } from "@angular/router";
import { UlogeEnum } from "../constants/uloge.enum";

interface IMenuItem {
  type: string; // Possible values: link/dropDown/icon/separator/extLink
  name?: string; // Used as display text for item and title for separator type
  state?: string; // Router state
  icon?: string; // Material icon name
  tooltip?: string; // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  forceShow?: boolean;  // Show menu item regardless of the roles/operations
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
  authData?: AuthData;
  hidden?: boolean;
}
interface IChildItem {
  childItemId?: number;
  type?: string;
  name: string; // Display text
  state?: string; // Router state
  icon?: string;
  sub?: IChildItem[];
  badges?: IBadge[];
  authData?: AuthData;
  hidden?: boolean;
}

interface AuthData {
  uloga: string;
  operacije: string[];
  mustMatchAll: boolean;
}

interface IBadge {
  color: string; // primary/accent/warn/hex color codes(#fff000)
  value: string; // Display text
}

@Injectable()
export class NavigationService {
  constructor(private tokenDataService: TokenDataService, private router: Router,) {
    this.createMenu();
  }

  menuAll: IMenuItem[] = [
    {
      name: "menuItems.recnikTipova",
      type: "dropDown",
      tooltip: "menuItems.recnikTipova",
      icon: "library_books",
      state: "/recnik-tipova",
      sub: [
        {
          name: "menuItems.osnovniTipovi",
          type: "link",
          state: "/osnovni-tipovi",
        },
        {
          name: "menuItems.poslovniTipovi",
          type: "link",
          state: "/poslovni-tipovi",
        },
        {
          name: "menuItems.slozeniTipovi",
          type: "link",
          state: "/slozeni-tipovi",
        }
      ],
    },
    {
      name: "menuItems.recnikPojmova",
      type: "dropDown",
      tooltip: "menuItems.recnikPojmova",
      icon: "library_books",
      state: "/recnik-pojmova",
      sub: [
        {
          name: "menuItems.pojmovi",
          type: "link",
          state: "",
        },
        // {
        //   name: "menuItems.sifarnickiPojmovi",
        //   type: "link",
        //   state: "sifarnicki-pojmovi",
        // },
        // {
        //   name: "menuItems.pojmoviUpisaniURecnik",
        //   type: "link",
        //   state: "/pojmovi-upisani-u-recnik",
        // }
      ]
    },
    {
      name: "menuItems.recnikPoruka",
      type: "dropDown",
      tooltip: "menuItems.recnikPoruka",
      icon: "library_books",
      state: "/recnik-poruka",
      sub: [
        {
          name: "menuItems.poruke",
          type: "link",
          state: "",
        }
      ]
    },
    {
      name: "menuItems.sluzbeneEvidencije",
      type: "link",
      tooltip: "menuItems.sluzbeneEvidencije",
      icon: "library_books",
      state: "/sluzbene-evidencije"
    },
    {
      name: "menuItems.administracijaSifarnika",
      type: "dropDown",
      tooltip: "menuItems.administracijaSifarnika",
      icon: "library_books",
      state: "/administracija-sifarnika",
      sub: [
         {
           name: "menuItems.sifarnickiPojmovi",
           type: "link",
           state: "/sifarnicki-pojmovi",
         },
        {
          name: "menuItems.sifarnici",
          type: "link",
          state: "/sifarnici",
        }
      ]
    },
    {
      name: "menuItems.administracija",
      type: "dropDown",
      tooltip: "menuItems.administracija",
      icon: "library_books",
      state: "/administracija",
      sub: [
        {
          name: "menuItems.klasifikacije",
          type: "link",
          icon: "library_books",
          state: "klasifikacija/pretraga-klasifikacija"
        },
        {
          name: "menuItems.domen",
          type: "link",
          state: "/domen",
        },
      ]
    },
    {
      name: "menuItems.pretrage",
      type: "dropDown",
      tooltip: "menuItems.pretrage",
      icon: "library_books",
      state: "/pretraga",
      sub: [
        {
          name: "menuItems.pretragaMetaregistra",
          type: "link",
          icon: "library_books",
          state: "/pretraga-metaregistra"
        }
      ]
    }
  ];


  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle: string = "Frequently Accessed";
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.menuAll);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {

    // this.menuItems.next(this.menuAll);
    // switch (menuType) {
    //   case "separator-menu":
    //     this.menuItems.next(this.separatorMenu);
    //     break;
    //   case "icon-menu":
    //     this.menuItems.next(this.iconMenu);
    //     break;
    //   default:
    //     this.menuItems.next(this.plainMenu);
    // }
  }
  menu: IMenuItem[] = [];

  createMenu(): void {
    this.menu.splice(0);
    this.menuAll.forEach(menuItem => {
      const clonedMenuItem = loadsh.cloneDeep(menuItem);
      if (this.isMenuItemAvailable(clonedMenuItem)) {
        this.menu.push(clonedMenuItem);
      }
    }, this);
    this.menuItems.next(this.menu);
  }

  private redirectPage(menu: IMenuItem[]) {
    let redirect = menu.findIndex(x => x.state == this.router.url)
    if (redirect < 0)
      this.router.navigate(['/']);
  }

  private isMenuItemAvailable(menuItem: IMenuItem) {
    let result = false;

    if (!menuItem.authData) {
      result = true;
    } else if ((menuItem.sub == null || menuItem.sub === undefined) && menuItem.authData) {
      if (this.tokenDataService.hasClaim(menuItem.authData)) {
        result = true;
      }
    } else {
      if (!!menuItem.sub) {
        const subItemNamesToRemove = [];

        menuItem.sub.forEach(subItem => {
          if (subItem) {

          }
          if (!this.tokenDataService.hasClaim(menuItem.authData)) {
            subItemNamesToRemove.push(subItem.name);
          }
        });

        subItemNamesToRemove.forEach(subItemName => {
          loadsh.remove(menuItem.sub, function (subItem) {
            return subItem.name === subItemName;
          });
        });

        if (menuItem.sub.length > 0) {
          result = true;
        }
      }
    }
    return result;
  }
}
